import { AnonServiceUsageStorage } from "@/services/storage/base/anon-service-usage-storage";

class KeyBpmFinderUsageStorage extends AnonServiceUsageStorage {}

const keyBpmUsageStorage = new KeyBpmFinderUsageStorage(
  "keyBpmUsageKey",
  "keyBpmUsageStore",
  "keyBpmUsageDB",
);
export { keyBpmUsageStorage };
